const _ = require('lodash');
const Immutable = require('immutable');
const moment = require('moment');
const k = require('@gral/constants');
const App = require('@gral/app');
const actStore = require('../actions/actStore');
const server = require('../actions/server').default;
const Store = require('./store');
const { ServerGralError } = require('@gral/exceptions');

// State
let _cx = Immutable.Map({
  uiState: k.uiState,
  data: Immutable.fromJS(localStorage.sessionData),
});
let _localData = null;
let _sessionData = null;
let _historyRoutes = null;

class ConnectionStore extends Store {
  static initClass() {
    this.prototype.storeDomain = 'cx';

    this.prototype.supportedActions = [
      k.actionTypes.LOGIN_START,
      k.actionTypes.LOGOUT,
      k.actionTypes.LOGIN_ERROR,
      k.actionTypes.LOGIN_SUCCESS,
      k.actionTypes.REFRESH_TOKEN_SUCCESS,
      k.actionTypes.REFRESH_TOKEN_ERROR,
      k.actionTypes.GET_SETTINGS,
      k.actionTypes.GET_SETTINGS_SUCCESS,
      k.actionTypes.CHECK_TOKEN_ERROR,
      k.actionTypes.CHANGE_ORGANIZATION_ROLE,
      k.actionTypes.PASSWORD_RECOVERY,
      k.actionTypes.PASSWORD_RECOVERY_SUCCESS,
      k.actionTypes.PASSWORD_RECOVERY_ERROR,
      k.actionTypes.PASSWORD_RESET,
      k.actionTypes.PASSWORD_RESET_SUCCESS,
      k.actionTypes.PASSWORD_RESET_ERROR,
      k.actionTypes.CHANGE_MAIN_SIDEBAR_STATE,
      k.actionTypes.MQTT_CONNECT,
      k.actionTypes.MQTT_CONNECT_SUCCESS,
      k.actionTypes.MQTT_CONNECT_ERROR,
    ];
  }

  constructor() {
    //@ts-ignore
    super(...arguments);
    this._loginAuto();
  }

  getState() {
    return _cx;
  }

  getStateData() {
    return _cx.get('data');
  }

  getToken() {
    let user = this.getUser();

    return user ? user.token : undefined;
  }
  getOrganizationId() {
    return _sessionData?.sessionBadge.organizationId ?? _localData?.sessionBadge.organizationId ?? undefined;
  }

  getIsAdmin() {
    return _sessionData?.sessionBadge.isAdmin ?? _localData?.sessionBadge.isAdmin ?? undefined;
  }
  getRoleId() {
    return _sessionData?.sessionBadge.roleId ?? _localData?.sessionBadge.roleId ?? undefined;
  }
  getBadge() {
    return _sessionData?.sessionBadge ?? _localData?.sessionBadge ?? undefined;
  }
  getUser() {
    return _sessionData?.user ?? _localData?.user ?? undefined;
  }
  getLocalBadge() {
    return _localData?.sessionBadge ?? undefined;
  }
  getSessionBadge() {
    return _sessionData?.sessionBadge ?? _localData?.sessionBadge ?? undefined;
  }
  getAclList() {
    return _sessionData?.userAcls ?? _localData?.userAcls ?? undefined;
  }

  isSuperadmin() {
    return (_localData != null ? _localData.level : undefined) === '0';
  }
  checkPermission(entityId, actionId) {
    return this.isSuperadmin() || _.get(_sessionData, ['userAcls', entityId, actionId], false);
  }

  /*   _loginStart(action, options) {
      const credentials = action.data;
      //this._updateState(k.loginStates.LOGGING_IN, null);
      server.logIn(credentials);
      return this.emitChange(action);
    } */

  _loginAuto() {
    this._loadSessionData();
    if (_localData == null) {
      return;
    }
    return this.emitChange();
  }

  _passwordRecovery(action) {
    server.passwordRecovery(action.data);
    return this.emitChange(action);
  }

  _passwordRecoverySuccess(action) {
    _cx = _cx.setIn(['passwordRecovery'], action.data);
    return this.emitChange(action);
  }

  _passwordRecoveryError(action) {
    const { data } = action;
    if (data instanceof ServerGralError) {
      //Store errors to let loginPage do his stuff
      _cx = _cx.setIn(['passwordRecovery'], {
        errors: { _gral: data.message },
      });
    } else {
      const msg =
        data.message ||
        'Something went wrong with the password recovery option. Please try again later or contact our customer support for assistance.';
      actStore.notify({
        msg,
        timeOut: 5000,
      });
    }
    return this.emitChange(action);
  }

  _passwordReset(action) {
    server.passwordReset(action.data);
    return this.emitChange(action);
  }

  _passwordResetSuccess(action) {
    _cx = _cx.setIn(['passwordReset'], action.data);
    return this.emitChange(action);
  }

  _passwordResetError(action) {
    _cx = _cx.setIn(['passwordReset'], action.data);
    return this.emitChange(action);
  }

  _loginSuccess(user) {
    // if badge is in sessionData use it, else use serverBadge
    const serverBadge = user.loginBadge;
    const localBadge = this.getLocalBadge();
    const sessionBadge = this.getSessionBadge();

    const session = { user, sessionBadge: serverBadge ?? sessionBadge ?? localBadge };

    this._saveLocalData(session);
    this._saveSessionData(session);
    //this._updateState(k.loginStates.LOADING_USER_PARAMS, session);

    //server.getSettings(serverBadge ?? badge, token);
    // schedule refresh token
    // return this.emitChange(action);
  }

  _refreshTokenSuccess(action) {
    return new Promise((resolve, reject) => {
      // update tokens
      try {
        const { token, refreshToken } = action.data;
        const sessionData = this._loadSessionData();

        if (sessionData) {
          _.assign(sessionData.user, { token, refreshToken });
          this._saveLocalData(sessionData);
          this._saveSessionData(sessionData);

          //this._updateState(k.loginStates.LOGGED_IN, sessionData);
          resolve('resolve');
          return this.emitChange();
        }
      } catch (error) {
        console.log(error);
        reject();
      }
    });
  }

  _refreshTokenError(action) {
    this._logout(action);
  }
  _errorRenewToken() {
    return new Promise((resolve, reject) => {
      this._clearDataStorage();
      //this._updateState(.LOGGED_OUT, null);
      resolve('resolve');
    });
  }

  _setSettingsACLsSuccess(settings, userAcls) {
    const sessionData = this._loadSessionData();
    _.assign(sessionData, { settings, userAcls });

    this._saveSessionData(sessionData);

    //this._updateState(k.loginStates.LOGGED_IN, sessionData);
    //return this.emitChange(action);
  }

  _loginError(action) {
    const { data } = action;

    const { message } = data?.response?.data?.error ?? {};

    //this._updateState(k.loginStates.LOGGED_OUT, null);

    this._clearDataStorage();
    const msg = message ?? 'Incorrect login or password. Please retry';
    actStore.notify({
      msg,
      timeOut: 5000,
    });
    return this.emitChange(action);
  }

  async _logout(action) {
    this._clearHistoryRoutes();
    this._clearDataStorage();
    //this._updateState(k.loginStates.LOGGED_OUT, null);
    return this.emitChange(action);
  }

  _updateState(loginState, data) {
    // save it in localStorage ?
    _cx = _cx.set('loginState', loginState);
    _cx = _cx.set('passwordReset', null);
    _cx = _cx.set('passwordRecovery', null);
    _cx = _cx.set('data', Immutable.fromJS(data));
  }

  _checkTokenError(action) {
    actStore.notify({
      msg: 'Your session has expired. Please log in again',
      timeOut: 5000,
    });
    this._logout(action);
    return this.emitChange(action);
  }

  /* _changeMainSidebarState(action) {
    _cx = _cx.setIn(['uiState', 'mainSidebarOpen'], action.data);
    return this.emitChange(action);
  } */

  //#region Local/Session storage
  _saveLocalData(sessionData) {
    localStorage.sessionData = JSON.stringify(sessionData);
    _localData = sessionData;
  }
  _saveSessionData(sessionData) {
    sessionStorage.sessionData = JSON.stringify(sessionData);
    _sessionData = sessionData;
  }
  _clearDataStorage() {
    sessionStorage.removeItem('sessionData');
    localStorage.removeItem('sessionData');
    _localData = null;
    _sessionData = null;
  }
  _loadSessionData() {
    const { sessionData } = sessionStorage;

    const localData = localStorage.sessionData;

    if (sessionData != null || localData != null) {
      _localData = localData && JSON.parse(localData);
      _sessionData = sessionData && JSON.parse(sessionData);
    }
    return _sessionData ?? _localData;
  }
  //#endregion

  //#region MQTT
  /* _mqttConnectErrorOldRemove(action) {
    _cx = _cx.set('mqttState', k.mqttStates.ERROR);
    return this.emitChange(action);
  } */

  /*  getMqttState() {
    return _cx.get('mqttState');
  }
 */
  getMqttCredentials() {
    const credentialsString = _sessionData?.user.mqttCredentials ?? _localData?.user.mqttCredentials ?? undefined;

    if (!credentialsString) {
      return null;
    }
    const [username, password] = credentialsString.split(':');
    return { username, password };
  }
  //#endregion

  //#region Routes
  _saveHistoryRoutes(historyRoutes) {
    localStorage.historyRoutes = JSON.stringify(historyRoutes);
    _historyRoutes = historyRoutes;
  }
  _clearHistoryRoutes() {
    localStorage.removeItem('historyRoutes');
    _historyRoutes = [];
  }
  loadHistoryRoutes() {
    const localHistoryRoutes = localStorage.historyRoutes;
    const sessionHistoryRoutes = sessionStorage.historyRoutes;

    const historyRoutes = sessionHistoryRoutes ?? localHistoryRoutes;
    if (historyRoutes != null) {
      _historyRoutes = JSON.parse(historyRoutes);
    }
    return _historyRoutes;
  }
  /* saveRoute(route) {
    const noSaveRoute = ['login'];
    if (noSaveRoute.includes(route.id)) return;

    let historyRoutes = this._loadHistoryRoutes();
    if (!historyRoutes) {
      historyRoutes = [];
    }
    if (historyRoutes.length > 0 && historyRoutes[historyRoutes.length - 1].path === route.path) return;
    const removeElementsAfter = (array, element) => {
      let index = -1;

      for (let i = 0; i < array.length; i++) {
        if (array[i].path === element.path) {
          index = i;
          break;
        }
      }

      if (index !== -1) {
        array.splice(index + 1);
      }

      return array;
    };
    const backRoute = removeElementsAfter([...historyRoutes], route);

    if (backRoute.length < historyRoutes.length) {
      historyRoutes = backRoute;
    } else if (route.id !== 'home') {
      const pageTitle = route.title || route.spec.pageTitle();
      route.pageTitle = pageTitle;
      historyRoutes.push(route);
    }

    this._saveHistoryRoutes(historyRoutes);
  } */
  /*   resetHistoryLevelRoutes(resetHistoryLevel) {

    //if(resetHistoryLevel===0)this._clearHistoryRoutes();
    let historyRoutes = this._loadHistoryRoutes();
    historyRoutes?.splice(resetHistoryLevel);
    this._saveHistoryRoutes(historyRoutes);
  } */
  /*   getHistoryRoutes() {
    const historyRoutes = this._loadHistoryRoutes();
    return historyRoutes;
  } */
  //#endregion
}
ConnectionStore.initClass();

// function successCallback() {
//   actServer.mqttConnectSuccess();
// }

module.exports = App.cxStore = new ConnectionStore();
